export const SEARCH_MODAL_ITEM_KIND = {
  Documentation: 'documentation',
  Glossary: 'glossary',
  QuickStart: 'quick-start',
} as const
